var map = {
	"./PAP_cat_icon_1-to-1.svg": [
		1890,
		29
	],
	"./PAP_cat_icon_1to1-other.svg": [
		1913,
		30
	],
	"./PAP_cat_icon_blog-theme-design.svg": [
		1914,
		31
	],
	"./PAP_cat_icon_book-cover-design.svg": [
		1915,
		32
	],
	"./PAP_cat_icon_brochure-or-menu-design.svg": [
		1916,
		33
	],
	"./PAP_cat_icon_business-card-design.svg": [
		1917,
		34
	],
	"./PAP_cat_icon_business-tagline.svg": [
		1918,
		35
	],
	"./PAP_cat_icon_design-consultation.svg": [
		1891,
		36
	],
	"./PAP_cat_icon_email-design.svg": [
		1919,
		37
	],
	"./PAP_cat_icon_icon-button-and-widget-design.svg": [
		1920,
		38
	],
	"./PAP_cat_icon_illustration-and-graphic-design.svg": [
		1921,
		39
	],
	"./PAP_cat_icon_infographics-design.svg": [
		1922,
		40
	],
	"./PAP_cat_icon_landing-page-design.svg": [
		1923,
		41
	],
	"./PAP_cat_icon_letterhead-and-stationery-design.svg": [
		1924,
		42
	],
	"./PAP_cat_icon_logo-and-business-card-design.svg": [
		1925,
		43
	],
	"./PAP_cat_icon_logo-and-social-media-assets-design.svg": [
		1926,
		44
	],
	"./PAP_cat_icon_logo-design.svg": [
		1927,
		45
	],
	"./PAP_cat_icon_magazine-cover-design.svg": [
		1928,
		46
	],
	"./PAP_cat_icon_merchandise-design.svg": [
		1929,
		47
	],
	"./PAP_cat_icon_mobile-ui-design.svg": [
		1930,
		48
	],
	"./PAP_cat_icon_naming-a-business-or-product.svg": [
		1931,
		49
	],
	"./PAP_cat_icon_other-clothing-design.svg": [
		1932,
		50
	],
	"./PAP_cat_icon_outdoor-or-signage-design.svg": [
		1933,
		51
	],
	"./PAP_cat_icon_package-graphics.svg": [
		1934,
		52
	],
	"./PAP_cat_icon_packaging-design.svg": [
		1935,
		53
	],
	"./PAP_cat_icon_postcard-or-flyer-design.svg": [
		1936,
		54
	],
	"./PAP_cat_icon_poster-design.svg": [
		1937,
		55
	],
	"./PAP_cat_icon_presentation-design.svg": [
		1938,
		56
	],
	"./PAP_cat_icon_product-design.svg": [
		1939,
		57
	],
	"./PAP_cat_icon_social-media-assets-design.svg": [
		1940,
		58
	],
	"./PAP_cat_icon_t-shirt-design.svg": [
		1941,
		59
	],
	"./PAP_cat_icon_tattoo-design.svg": [
		1942,
		60
	],
	"./PAP_cat_icon_vehicle-wrap-design.svg": [
		1943,
		61
	],
	"./PAP_cat_icon_wall-mural-art-design.svg": [
		1944,
		62
	],
	"./PAP_cat_icon_web-banner-design.svg": [
		1945,
		63
	],
	"./PAP_cat_icon_website-design.svg": [
		1946,
		64
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1872;
module.exports = webpackAsyncContext;